export default [
  {
    label: 'Direct',
    value: 'direct',
  },
  {
    label: 'Indirect',
    value: 'indirect',
  },
  {
    label: 'Custom',
    value: 'custom',
  },
];
